'use client';

import type { Content, GroupField, KeyTextField } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import type { Simplify } from '../../../../prismicio-types';
import { Icon } from '@/assets/icons/Icon';
import { Container } from '@/components';

import styles from './achievementsInner.module.scss';
import { BoxContainer } from '@/components/BoxContainer/BoxContainer';
import { useVisible } from '@/hooks';
import { consistentAnimationDuration } from '@/utils';

interface AchievementsInnerProps {
  achievements: GroupField<
    Simplify<Content.AchievementsSliceDefaultPrimaryAchievementsItem>
  >;
  text: KeyTextField;
}

const components: JSXMapSerializer = {
  heading5: ({ children }) => (
    <h5 className={styles.description}>{children}</h5>
  ),
};

export const AchievementsInner = ({
  achievements,
  text,
}: AchievementsInnerProps) => {
  const [isVisible, id] = useVisible();

  const isVisibleStyles = isVisible ? styles.isVisible : '';

  return (
    <BoxContainer styles={styles.container}>
      <Container>
        <article className={styles.wrapper} id={id}>
          <p className={`${styles.text} ${isVisibleStyles}`}>{text}</p>
          <ul className={styles.achievements}>
            {achievements.map((item, index) => (
              <li
                className={`${styles.item} ${isVisibleStyles}`}
                style={consistentAnimationDuration(1.1, index)}
                key={`${item.icon} ${index}`}
              >
                <Icon icon={item.icon} />
                <div className={styles.item_text}>
                  <p className={styles.value}>{item.value}</p>
                  <PrismicRichText
                    field={item.description}
                    components={components}
                  />
                </div>
              </li>
            ))}
          </ul>
        </article>
      </Container>
    </BoxContainer>
  );
};
